import axios from "axios";
import Config from "../../../config";

const v2_actionListGroupEvents = (chatId, { limit = 100, offset = 0 } = {}) => axios({
    method: "get",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/events?limit=${limit}&offset=${offset}`
});

export default v2_actionListGroupEvents;
